<template>
	<div id="searchBar">
    <div class="top" :style="style" :class="{ color: color }" v-if="minWidth > 500">
      <div class="top-index">
        <div class="logo">
          <div class="dd">
            <img src="../assets/img/footer/logo.png" alt="">
          </div>
          <div class="cl">
            <div v-for="(item, index) in tabTitle" :key="index" @click="tss(item)"
              :class="item.id === tab ? 'active' : '' "
              class="cc">
              <div>
                <div>{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	data() {
		return {
			tab: 0,
			tabTitle: [
				{
					id: 0,
					name: '首页',
					url: '/home',
				},
				{
					id: 1,
					name: '我们的实力',
					url: '/strength',
				},
        {
					id: 2,
					name: '解决方案',
					url: '/solution',
				},
        {
					id: 3,
					name: '合作伙伴',
					url: '/partner',
				}
			],
      minWidth:'',
      style: {
        backgroundColor: "",
      },
      color: false,
		}
	},
	components: {},
  created() {

  },
  mounted() {
    window.addEventListener('resize', this.getWidth);
    this.getWidth()

    window.addEventListener('scroll', this.handleScroll)

  },
	methods: {
    handleScroll () { //改变元素#searchBar的top值
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      var offsetTop = document.querySelector('#searchBar').offsetTop;
      if(scrollTop<=200){
        offsetTop = 300 - Number(scrollTop);
        document.querySelector('#searchBar').style.top = offsetTop+'px';
      }else{
        document.querySelector('#searchBar').style.top = '100px';
      }
      // console.log('666', scrollTop)
      if (scrollTop == 0) {
        this.tab = 0
      }
      if ( scrollTop.toFixed(0) < 600 && scrollTop.toFixed(0) > 500) {
        this.tab = 1
        // alert('我去')
      }
      if ( scrollTop.toFixed(0) < 2100 && scrollTop.toFixed(0) > 2000) {
        this.tab = 2
        // alert('我去')
      }
      if ( scrollTop.toFixed(0) < 4400 && scrollTop.toFixed(0) > 4300) {
        this.tab = 3
        // alert('我去')
      }

      if (scrollTop) {
        this.style.backgroundColor = `rgba(18, 22, 74,${scrollTop /
          (scrollTop + 80)})`;
        this.color = true;
      } else if (scrollTop == 0) {
        this.style.backgroundColor = "transparent";
        this.color = false;
      }
    },
    getWidth(){
      // this.height = window.innerWidth - 70 + 'px';
      this.minWidth = String(window.innerWidth)
    },
		tss(item) {
			this.tab = item.id
      // this.$router.push(item.url)
      if (item.id == 0) {
        document.documentElement.scrollTop = 0
      }
      if (item.id == 1) {
        document.documentElement.scrollTop = 500
      }
      if (item.id == 2) {
        document.documentElement.scrollTop = 2000
      }
      if (item.id == 3) {
        document.documentElement.scrollTop = 4300
      }
		}
	},
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
}
</script>

<style lang="scss" scoped>
.top {
	width: 100%;
	height: 80px;
	// background: linear-gradient(90deg, #12d6df, #96009b);
	// box-shadow: 2px 0px 20px 0px rgba(1, 94, 171, 0.2);
	position: fixed;
	z-index: 999;
	.top-index {
		.logo {
			display: flex;
			align-items: center;
      justify-content: flex-end;
			height: 80px;
      padding-right: 20%;
			span {
				font-size: 28px;
				font-family: PingFang SC;
				font-weight: 500;
				color: #ffffff;
				margin-left: 15px;
			}
      .dd {
        position: absolute;
        left: 50px;
        img {
          width: 140px;
          height: 45px;
        }
      }
			.cl {
				display: flex;
				width: 35%;
				justify-content: space-between;
				// align-items: center;
				margin-top: 2%;
				.cc {
					font-size: 18px;
					font-family: PingFang SC;
					font-weight: 500;
					// color: #b9b8b8;
          color: #ffffff;
					cursor: pointer;
          // display: flex;
          // width: 15%;
          // text-align: center;
				}
				.active {
					font-size: 20px;
					font-family: PingFang SC;
					font-weight: 400;
					color: #ffffff;
          padding-bottom: 20px;
					border-bottom: 3px solid #ffffff;
					cursor: pointer;
          // width: 15%;
				}
				.el-dropdown {
					font-size: 20px;
					color: #d1cccc;
				}
				.active .el-dropdown {
					font-size: 20px;
					color: #ffffff;
					border-bottom: none;
				}
				el-dropdown-link {
					cursor: pointer;
					color: #409eff;
				}
				.el-icon-arrow-down {
					font-size: 12px;
				}
			}
		}
	}
}
</style>
